import apiClient from '../apiClient';
import { GET_EXCURTION_BY_CITY_URL } from '../apiUrl';

const getExcurtionByCityApi = id => {
  return apiClient.get(GET_EXCURTION_BY_CITY_URL(id));
};

export default getExcurtionByCityApi;
